module.exports = "/images/logo-sobatppt-light-347f7d5ee07c27f795df56b2866da877.png";